export default function GlassCard({ children, className = '', hover = false, onClick = undefined }) {
  return (
    <div
      className={`${hover ? 'glass-hover cursor-pointer' : 'glass'} p-6 ${className}`}
      onClick={onClick}
    >
      {children}
    </div>
  )
}
